import { render, staticRenderFns } from "./religion.vue?vue&type=template&id=51c68d82&"
import script from "./religion.vue?vue&type=script&lang=js&"
export * from "./religion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports